import React, {Dispatch, SetStateAction} from 'react'
import {DocusealBuilder} from '@docuseal/react'

const DocusealTemplate = ({
  token,
  setDocusealId,
  isView,
  setIsInValidTemplate,
}: {
  token?: string
  setDocusealId?: Dispatch<SetStateAction<number | undefined>>
  isView?: boolean
  setIsInValidTemplate?: Dispatch<SetStateAction<boolean>>
}) => {
  return (
    <div className='mx-5 mb-10'>
      <div className='w-100 bg-white mt-4 pb-10 mb-10'>
        {token && (
          <DocusealBuilder
            host='esign.recordskeeper.ai'
            token={token}
            preview={isView ? true : false}
            customCss='#title_container {display: none;} #add_document_button {display:none;}'
            onChange={(data) => {
              if (setIsInValidTemplate) {
                if (
                  data.documents &&
                  data.documents.length > 0 &&
                  data.submitters.every((submitter: any) =>
                    data.fields.some((field: any) => field.submitter_uuid === submitter.uuid)
                  )
                ) {
                  setIsInValidTemplate(false)
                } else {
                  setIsInValidTemplate(true)
                }
              }
            }}
            onLoad={(data) => {
              if (
                !(
                  data.documents &&
                  data.documents.length > 0 &&
                  data.submitters.every((submitter: any) =>
                    data.fields.some((field: any) => field.submitter_uuid === submitter.uuid)
                  )
                ) &&
                setIsInValidTemplate
              ) {
                setIsInValidTemplate(true)
              }
              if (setDocusealId) {
                setDocusealId(data.id)
              }
            }}
          />
        )}
      </div>
    </div>
  )
}

export default DocusealTemplate
